import { useAddToFavorites, useRemoveFromFavorites } from '../api/favorites';
import { useCampContext } from '../context/CampContext';
import { useUserContext } from '../context/UserContext';
import { useNotifications } from '../context/NotificationContext';
import { Camp } from '../utils/types';

export const useFavoriteToggle = () => {
  const addToFavoritesMutation = useAddToFavorites();
  const removeFromFavoritesMutation = useRemoveFromFavorites();
  const { favorites, addToFavorites, removeFromFavorites } = useCampContext();
  const { isLoggedIn } = useUserContext();
  const { showSuccess, showError } = useNotifications();

  const isInFavorites = (camp: Camp) => {
    return favorites.some(favorite => favorite.id === camp.id);
  };

  const handleFavoriteToggle = async (camp: Camp, favoriteId?: string) => {
    if (!isLoggedIn) {
      showError('Please log in to manage favorites', new Error('User not logged in'));
      return;
    }

    const id = favoriteId || '1';
    const isFavorite = isInFavorites(camp);

    try {
      if (isFavorite) {
        await removeFromFavoritesMutation.mutateAsync({ favoriteId: id, campId: camp.id });
        removeFromFavorites(camp);
        showSuccess('Camp removed from favorites');
      } else {
        await addToFavoritesMutation.mutateAsync({ favoriteId: id, campId: camp.id });
        addToFavorites(camp);
        showSuccess('Camp added to favorites');
      }
    } catch (error: any) {
      showError('Failed to update favorites', error);
    }
  };

  return {
    isInFavorites,
    handleFavoriteToggle,
    isPending: addToFavoritesMutation.isPending || removeFromFavoritesMutation.isPending
  };
};
